package app.nestbridge.feature.children.service

import app.nestbridge.feature.children.api.ChildApiClient
import app.nestbridge.feature.children.model.Child
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class, boundType = ChildService::class)
@Inject
class DefaultChildService(
    private val apiClient: ChildApiClient,
) : ChildService {

    override suspend fun get(id: String): Child? = apiClient.fetch(id)?.toDomain()

    override suspend fun findAll(): List<Child> = apiClient.fetchAll().map { it.toDomain() }

    override suspend fun save(child: Child): Child = apiClient.save(child.toDto()).toDomain()

}
